import React from 'react'
import { Button } from 'react-bootstrap'
import { getOAuthUrl } from '../../services/auth'
import { isMobileMode } from '../ProPlans/PricingModalContent'

const PROVIDERS = ['google', 'github', 'microsoft', 'yahoo']

const Login = ({ provider, onClick, disabled }) => (
  <Button
    className="btn social-button border"
    variant="outline-primary"
    type="submit"
    disabled={disabled}
    {...(onClick && { onClick: () => onClick(provider) })}
    {...(!onClick && { href: getOAuthUrl(provider) })}
  >
    <img className="m-auto" src={`/assets/icons/${provider}.svg`} alt={`${provider} logo`} />
  </Button>
)

const SocialLogin = ({ className = '', onClick, disabled }) => {
  const availableProviders = isMobileMode() ? PROVIDERS.filter((provider) => provider !== 'google') : PROVIDERS

  return (
    <div className={`flex gap-2 ${className}`}>
      {availableProviders.map((p) => (
        <Login key={p} provider={p} onClick={onClick} disabled={disabled} />
      ))}
    </div>
  )
}

export default SocialLogin
